import React, { Component } from 'react';

import { connect } from 'react-redux';

import ListView from './ListView';
import BobLoadingMask from '../../components/BobLoadingMask';

import * as ArchitectActions from '../../actions/architectActions';
import * as CoreActions from '../../actions/coreActions';
import * as HomeActions from '../../actions/homeActions';
import * as SiteActions from '../../actions/siteActions';

import classes from './Home.module.css';

class Home extends Component {
    state = {
        listView:        true,
        mapView:         false,
        view:            'List',
        showFilterPanel: false,
        showHealthPanel: false
    };

    async componentDidMount() {
        const {
            companyInfo,
            fetchCompanySites,
            getCardFaultScores,
            setProgressBarLoading,
            setTreeType
        } = this.props;

        setTreeType('home');

        setProgressBarLoading(true);

        await getCardFaultScores(companyInfo.companyId);
        await fetchCompanySites(companyInfo.companyId);
    }

    handleMapClick = () => {
        this.setState({
            listView: false,
            mapView:  true,
            view:     'Map'
        });
    };

    handleListClick = () => {
        const { toggleSiteSelection } = this.props;

        this.setState({
            listView: true,
            mapView:  false,
            view:     'List'
        });

        toggleSiteSelection(false);
    };

    handleFilterTogglePanel = () => {
        this.setState(state => ({
            showFilterPanel: !state.showFilterPanel
        }));
    }

    handleHealthTogglePanel= () => {
        this.setState(state => ({
            showHealthPanel: !state.showHealthPanel
        }));
    }

    render() {

        return (
            <div className={classes.Home}>
                <ListView {...this.props} />
                {
                    this.props.progressBarLoading ?
                        <BobLoadingMask />
                        :
                        null
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:        state.companyInfo,
        companySites:       state.site.companySites,
        healthChecks:       state.home.healthChecks,
        progressBarLoading: state.core.progressBarLoading,
        rule:               state.svcRequest.raw
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...CoreActions,
    ...HomeActions,
    ...SiteActions
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
